import React, { useState, useEffect } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import Pusher from 'pusher-js';
import { useQuery , useMutation } from '@apollo/react-hooks';


import {GET_NOTIFICATION} from './api';
import {CONVERSATION_READ} from '../messages/apis';

import InputBase from '@material-ui/core/InputBase';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import { Navbar, Nav, Container } from 'react-bootstrap';
import {Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem} from '@material-ui/core';
import spreago from './images/logo.png';
import './header.style.css';

// user badge  style
const StyledBadge = withStyles(theme => ({
    badge: {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: '$ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}))(Badge);
// search bar style
const useStyles = makeStyles(theme => ({
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: 'rgb(247, 245, 245)',
        '&:hover': {
            backgroundColor: 'rgb(247, 245, 245)',
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing(7),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#606060'
    },
    inputRoot: {
        color: '#606060',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 7),
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200,
            },
        },
    },
}));



function Header(props) {
    // const [ flag, setFlag ] = useState(0);
    let flag = 0;
    const { loading, error, data ,refetch } = useQuery(GET_NOTIFICATION);

    // user the serach bar style
    const classes = useStyles();
    // get user type 
    const userType = JSON.parse(localStorage.getItem('jwt'))?.user?.typeName;
    if( !userType){
        localStorage.setItem('jwt','');
        props.history.push({
            pathname : '/'
        })
    }
    let links = new Map();
    let sideMenu = new Map();
    const createNotification = (selector , counter)=>{
        if(counter !== 0){

            let div = document.createElement('div');
            div.classList = ['orange-counter notify'];
            let p = document.createElement('p');
            p.appendChild(document.createTextNode(counter))
            div.appendChild(p)
            let parent = document.querySelector(selector)
            parent.appendChild(div)
        }
    }
    // handle menu by user type
    if (userType === 'Applicant') {

        links.set("/profile", "Profile");
        links.set("/visumes", "Visumes");
        links.set("/messages", "Messages");
        links.set("/notifications", "Notifications");
        sideMenu.set("/profile", "View Profile");
        sideMenu.set("/myJobs", "My Jobs");
    }
    else {
        links.set('/companyProfile', "Company");
        links.set('/jobs', "Jobs");
        links.set('/messages', "Messages");
        links.set('/notifications', "Notifications");
        sideMenu.set("/companyProfile", "View Profile");
        sideMenu.set("/explorePremiumFeatures", "Explore premium Features");
    }
    const handleLinks = () => {
        let rows = [];
        for (let [key, value] of links.entries()) {
            rows.push(<Link className="nav-link" to={key}>{value}</Link>)
        }
        return <Nav className="mr-auto">{rows}</Nav>
    }
    const handleDropDown = () => {
        let sideMenuRows = []
        const user = JSON.parse(localStorage.getItem('jwt')).user;

        if (user.typeName === 'employer') {
            if (userData) {
                sideMenuRows.push(<li class="pr-3 pl-3">
                    <h6 class="mb-0"> {userData.company ? userData.company.name : ''} </h6>
                    <small class="text-grey">{userData.company ? (userData.company.Industry) ? userData.company.Industry.name : '' : ''}</small>
                </li>)

                let list = document.querySelectorAll('#menu-list-grow li');
                if (list[1]) {
                    list[1].querySelector('a').classList.add('text-orange', 'underline')
                }
            }
        }
        for (let [key, value] of sideMenu.entries()) {
            sideMenuRows.push(<MenuItem className="custom-border-bottom">
                <Link to={key}>{value}</Link>
            </MenuItem>)
        }
        return (
            <div>
                {sideMenuRows}
            </div>
        )
    }
    // save user data 
    const [userData, setuserData] = useState(0);
    if (props.data && userData !== props.data) setuserData(props.data)

    const getUserData = () => {
        if (localStorage.jwt) {
            //handle fetch specialities and tags dropdown   
            const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
            const uri = 'https://spreago.black-squares.com/graphql';
            const id = JSON.parse(localStorage.jwt).user.id;
            const apolloFetch = createApolloFetch({ uri });
            apolloFetch.use(({ request, options }, next) => {
                if (!options.headers) {
                    options.headers = {};  // Create the headers object if needed.
                }
                options.headers['authorization'] = `Bearer ${token}`;

                next();
            });
            //get user data
            apolloFetch({
                query:
                    `query($user_id : Int !){
                        user(id: $user_id){
                        id
                        name
                        email
                        image
                        is_active
                        is_verified
                        created_at
                        updated_at
                        my_bio{
                            title
                            speciality{
                                name
                            }
                            created_at
                            video{
                            duration 
                            frame{
                                url
                            }
                            url
                            }
                        }
                        Locale
                        address
                        image
                        cities_id
                        countries_id
                        phone
                        headlines
                        date_of_birth
                        bio
                        years_of_experience
                        profile_image{
                            url
                        }
                        profile_pdf{
                            url
                        }
                        company {
                            id
                            name
                            website_url
                            description
                            website_url
                            logo{id url}
                            Industry{
                                id
                                context
                                name
                                name_en
                                name_ar
                              }
                          }
                  }
              }
       `, variables: { user_id: id }
            }).then(res => {
                setuserData(res.data.user)
            });

        }
    }
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const prevOpen = React.useRef(open);
    const [show, setShow] = React.useState(false);
    
    // hendle open and close menu 
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    useEffect(() => {

        if(data){
            createNotification("a[href='#/messages']" , data?.me.conversationsUnRead);
            createNotification("a[href='#/notifications']", data?.me.countNotificationsUnRead);
        }

        // handle get user data
        getUserData();
        let searchInput =  document.querySelector('#searchInput');
        if(searchInput){
            searchInput.addEventListener('keypress', (e) =>{
                if (e.key === 'Enter') {
                    let searchKey = document.querySelector('#searchInput').value;
                    props.history.push({
                        pathname: '/searchResults',
                        state : searchKey ,
                        search : searchKey
                    });
                    searchInput.value = '';
                }
            });
        }

        // get notification 
        const userAuth = JSON.parse(localStorage.getItem('jwt'));
        const pusher = new Pusher('websocket',{
                      wsHost       : 'spreago.black-squares.com' ,
                      wssPort      : '6001' ,
                      authEndpoint : 'https://spreago.black-squares.com/api/authEndpoint' ,
                      forceTLS     : false             ,
                      disableStats : true              ,
                      auth: {
                        headers: {
                          'authorization': `Bearer ${userAuth.BearerTokenResponse?.access_token}`
                        }
                      }
                  });
        var channel = pusher.subscribe(`private-App.Models.User.${userAuth.user?.id}`);
        channel.bind('NewMassage', (res) =>{
            createNotification("a[href='#/messages']" , res.my_attrs.my_conversationsUnRead);
        });
        channel.bind('NewNotification', (res)=> {
            createNotification("a[href='#/notifications']",res.my_attrs.my_countNotificationsUnRead);
         });

         document.querySelector("a[href='#/notifications'").addEventListener("click",()=>{
            let notification =  document.querySelectorAll("a[href='#/notifications'] .notify")
            if(notification){
                notification.forEach(ele=>ele.remove())
             }
            if (localStorage.jwt) {
                //handle fetch specialities and tags dropdown   
                const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
                const uri = 'https://spreago.black-squares.com/graphql';
                const id = JSON.parse(localStorage.jwt).user.id;
                const apolloFetch = createApolloFetch({ uri });
                apolloFetch.use(({ request, options }, next) => {
                    if (!options.headers) {
                        options.headers = {};  // Create the headers object if needed.
                    }
                    options.headers['authorization'] = `Bearer ${token}`;
    
                    next();
                });
                //get user data
                apolloFetch({
                    query:
                        `mutation{
                          UserMarkNotificationsAsRead{
                            Status{
                              code
                              message
                            }
                          }
                        }`
                }).then(res => {
                   if(res.data.UserMarkNotificationsAsRead.code === 200){
                        // createNotification("a[href='#/notifications']", 0);  
                   }
                });
    
            }
         })
         document.querySelector("a[href='#/messages']").addEventListener("click",()=>{
             let notification = document.querySelectorAll("a[href='#/messages'] .notify");
             if(notification){
                notification.forEach(ele=>ele.remove())
             }
         })
    }, [data , refetch]);
    if(flag === 1){
       refetch();
   }

    return (
        <Paper>
            <Container>
                <Navbar className="container pr-0 pl-0" bg="white" expand="lg">
                        <Link className="navbar-brand" to='/homepage'>
                            <img alt="spreago logo" src={spreago} />
                        </Link>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        {handleLinks()}
                        <Nav className="align-items-end">
                            {
                                (userType === 'Applicant') &&
                                <div className={classes.search}>
                                    <div className={classes.searchIcon}>
                                        <SearchIcon />
                                    </div>
                                    <InputBase
                                        placeholder="Search…"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        id="searchInput"
                                        inputProps={{ 'aria-label': 'search' }}
                                    />
                                </div>
                            }
                            <StyledBadge
                                className="pl-1 online-avatar order-sm-2 order-2"
                                overlap="circle"
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                variant="dot">
                                <div className="pl-1">
                                    <Avatar alt={userData && userData.name} src={userData && (userData.profile_image) ? userData.profile_image.url : userData?.company?.logo?.url} />
                                </div>
                            </StyledBadge>
                            <button
                                className=" order-sm-3 order-1 p-0 bg-transparent border-0 mr-2 ml-2"
                                ref={anchorRef}
                                aria-controls={open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                onClick={handleToggle}
                            >
                                <ArrowDropDownIcon />
                            </button>
                            <Popper style={{ zIndex : '123'}} className="menuDropdown" open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal >
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom', minWidth: '11rem' }}
                                    >
                                        <Paper>
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <MenuList autoFocusItem={open} id="menu-list-grow">
                                                    {handleDropDown()}
                                                    <MenuItem >
                                                        <button
                                                            onClick={() => setShow(true)}
                                                            className="border-0 bg-transparent">
                                                            <Link>Language </Link></button>
                                                    </MenuItem>
                                                    <MenuItem className="custom-border-bottom">
                                                        <Link>Help & support</Link>
                                                    </MenuItem>
                                                    <MenuItem >
                                                        <Link
                                                            className=""
                                                            to="/"
                                                            onClick={() => {
                                                                localStorage.clear();
                                                                return false;
                                                            }}
                                                        >
                                                            Logout
                                                        </Link>
                                                    </MenuItem>
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Container>
        </Paper>
    );
}
export default withRouter(Header);